import React from 'react';
import ModalRouter from 'shared/containers/ModalRouter';
import NewReferralTypeModal from 'agent_portal/components/NewReferralTypeModal';
import MasqueradeBanner from './MasqueradeBanner';

const modals = [{ name: 'newReferralTypeModal', component: NewReferralTypeModal }];

export default props => (
  <div>
    {props.children}
    <ModalRouter modals={modals} />
    <MasqueradeBanner />
  </div>
);
